import { Instruction, OpCode } from '../internal.js';
/**
 * Sign To Instruction.
 *
 * The given signature and pubkey signs the transaction instructions before this
 * instruction.
 */
export class SignToInstruction extends Instruction {
    sig;
    pubkey;
    constructor(sig, pubkey) {
        super(OpCode.SIGNTO);
        this.sig = sig;
        this.pubkey = pubkey;
    }
}
/**
 * Sign To Args Serializer object - implements the Serializable interface.
 */
export const SignToArgsSerializer = {
    read(buf) {
        const sig = buf.readFixedBytes(64);
        const pubkey = buf.readFixedBytes(32);
        return new SignToInstruction(sig, pubkey);
    },
    write(buf, instruction) {
        buf.writeFixedBytes(instruction.sig);
        buf.writeFixedBytes(instruction.pubkey);
        return buf;
    }
};
